import { makeVar } from '@apollo/client'
import { EmpoloyeeType } from 'queries/employee-lookup'
import { GetUserProfileResult } from 'ts/interfaces/userProfile.interface'

export const userProfileVar = makeVar<EmpoloyeeType | null>(null)
export const userInfoVar = makeVar<GetUserProfileResult | null>(null)

const DEFAULT_EMP_ID = 24046287

export const setUserProfile = (userProfile: EmpoloyeeType) => {
  userProfileVar(userProfile)
}

export const setUserInfo = (userInfo: GetUserProfileResult) => {
  if (
    userInfo.userSecurityProfile?.securityProfile?.userProfile &&
    !userInfo.userSecurityProfile.securityProfile.userProfile.empId
  ) {
    userInfo.userSecurityProfile.securityProfile.userProfile.empId = DEFAULT_EMP_ID
  }
  userInfoVar(userInfo)
}

export const userLockSatatusVar = makeVar<boolean>(false)

export const setUserLockStatus = (status: boolean) => {
  userLockSatatusVar(status)
}

export const getUserLockStatus = (): boolean => {
  return userLockSatatusVar()
}
